import * as React from 'react';
import { HEADER_HEIGHT, SIDEBAR_WIDTH } from '../../layout';
import { useGroupBy } from '../../state/context';
import SolutionSidebarRows from './SolutionsSidebarRows';
import OrganizationsSidebarRows from './OrganizationsSidebarRows';

const RowsSidebar = () => {
  const [groupBy] = useGroupBy();
  const innerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const handleScroll = () => {
      if (innerRef.current) {
        innerRef.current.style.transform = `translateY(-${window.scrollY}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div
      className="fixed left-0 right-0 bottom-0 z-10  shadow-2xl"
      style={{
        top: `${HEADER_HEIGHT}px`,
        width: `${SIDEBAR_WIDTH}px`,
      }}
    >
      <div
        ref={innerRef}
        className="w-full h-full"
      >
        {groupBy === 'solution' && (
          <SolutionSidebarRows />
        )}
        {groupBy === 'organization' && (
          <OrganizationsSidebarRows />
        )}
      </div>
    </div>
  );
};

export default RowsSidebar;
